import React from 'react'
import { BarChart3 } from "lucide-react";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    AreaChart,
    Area
} from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/Card';

const PageViewsChart = ({ pageViews }) => {
    return (
        <Card className="shadow-elegant">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5 text-primary" />
                    Sayfa Görüntülemeleri ve Oturumlar
                </CardTitle>
                <CardDescription>Günlük performans genel bakışı</CardDescription>
            </CardHeader>

            <CardContent>
                <ResponsiveContainer width="100%" height={300}>
                    <AreaChart data={pageViews}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                        <XAxis dataKey="name" stroke="#888" />
                        <YAxis stroke="#888" />
                        <Tooltip
                            formatter={(value, name) => {
                                const labelMap = {
                                    views: "Sayfa Görüntüleme",
                                    sessions: "Oturum Sayısı",
                                };
                                return [value, labelMap[name] || name];
                            }}
                            contentStyle={{
                                backgroundColor: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            }}
                        />
                        <Area
                            type="monotone"
                            dataKey="views"
                            stackId="1"
                            stroke="#A855F7"
                            fill="url(#colorViews)"
                        />
                        <Area
                            type="monotone"
                            dataKey="sessions"
                            stackId="1"
                            stroke="#06B6D4"
                            fill="url(#colorSessions)"
                        />
                        <defs>
                            <linearGradient id="colorViews" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#A855F7" stopOpacity={0.3} />
                                <stop offset="95%" stopColor="#A855F7" stopOpacity={0.1} />
                            </linearGradient>
                            <linearGradient id="colorSessions" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#06B6D4" stopOpacity={0.3} />
                                <stop offset="95%" stopColor="#06B6D4" stopOpacity={0.1} />
                            </linearGradient>
                        </defs>
                    </AreaChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    )
}

export default PageViewsChart